import { Button, ButtonProps } from 'antd'
import { IssueStatus, Permission } from '@cims-online/shared'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { Issue } from '../../../../../IssueTrackerContext/types'
import { useIssueTrackerContext } from '../../../../../IssueTrackerContext'

const StatusButton: React.FC<Issue> = (issue) => {
  const { draftSubmitModal, actionModal } = useIssueTrackerContext()
  const creator = useCheckPermission(Permission.CreateIssue)
  const responder = useCheckPermission(Permission.RespondToIssue)
  const giver = useCheckPermission(Permission.GiveIssueDisposition)
  const closer = useCheckPermission(Permission.CloseIssue)
  const { id, name } = IssueStatus.fromIdOrFail(issue.statusId)
  const props = {
    type: 'link',
    style: { whiteSpace: 'normal', padding: 0, display: 'inline-flex' },
  } as ButtonProps
  if (id === IssueStatus.Draft.id && creator)
    return (
      <Button {...props} onClick={() => draftSubmitModal.toggle(issue)}>
        {name}
      </Button>
    )
  if (
    (id === IssueStatus.PendingResponse.id && responder) ||
    (id === IssueStatus.PendingDisposition.id && giver) ||
    (id === IssueStatus.PendingClosure.id && closer)
  )
    return (
      <Button {...props} onClick={() => actionModal.toggle(issue)}>
        {name}
      </Button>
    )
  return <>{name}</>
}

export default StatusButton
